import { render, staticRenderFns } from "./AffiliateReferralSettingsIcon.vue?vue&type=template&id=03b8a0e7&scoped=true"
import script from "./AffiliateReferralSettingsIcon.vue?vue&type=script&lang=js"
export * from "./AffiliateReferralSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8a0e7",
  null
  
)

export default component.exports